var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSuinoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.26 36.4999C32.53 37.6999 36.76 37.9799 40.55 36.5399C44.68 33.5699 47.23 29.4 46.37 26.4799C45.9 26.0499 45.52 25.5699 44.72 25.4599C44.39 25.4099 43.62 25.5599 43.26 25.4999C41.58 25.2399 40.84 25.2299 39.26 23.4999C38.53 22.7099 37.62 18.5699 35.49 15.8199",
    stroke: "#8B1B1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.26 37.5C32.06 39.29 31.81 40.06 27.34 39.8C18.88 39.3 14.94 47.5 5.45996 47.5",
    stroke: "#8B1B1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 16.98C22.94 17.87 23.05 18.45 25.62 22.04C34.25 19.48 39.29 11.82 40.31 7.89001C37.37 8.04001 28.66 10.49 27.01 11.6C27.01 11.6 24.3 9.98001 22.75 9.32001",
    stroke: "#8B1B1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.93 8.26C29.05 7.04 31.45 4.13 32.26 2.5C25.27 3.48 22.53 4.2 17.26 6.5C13.55 4.72 9.34001 4.5 6.26001 4.5",
    stroke: "#8B1B1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSuinoRed);
export default __webpack_public_path__ + "static/media/ic_suino_red.5018ab07a9def433408f26cee2943965.svg";
export { ForwardRef as ReactComponent };